import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-countdown-dialog',
  templateUrl: './countdown-dialog.component.html',
  styleUrls: ['./countdown-dialog.component.css']
})
export class CountdownDialogComponent {
  countdown: number = 10;

  constructor(
    public dialogRef: MatDialogRef<CountdownDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.startCountdown();
  }

  startCountdown() {
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(interval);
        this.dialogRef.close(true);  // Close the dialog and indicate redirection
      }
    }, 1000);
  }

  cancel(): void {
    this.dialogRef.close(false);  // Close the dialog and cancel redirection
  }
}
